const MINUTES_IN_HOUR = 60;
const MINUTES_IN_DAY = 60 * 24;

// Frase legivel de status de vencimento a partir do tempo restante em minutos.
// >=24h -> dias, 1-24h -> horas, <1h -> minutos. Negativo => vencido.
export const formatDueStatus = minutes => {
  const safe = Number.isFinite(minutes) ? minutes : 0;
  const overdue = safe < 0;
  const abs = Math.abs(safe);

  if (abs < 1) {
    return { overdue: false, text: "Vence agora" };
  }

  let amount;
  if (abs < MINUTES_IN_HOUR) {
    amount = `${Math.floor(abs)} min`;
  } else if (abs < MINUTES_IN_DAY) {
    const hours = Math.floor(abs / MINUTES_IN_HOUR);
    amount = `${hours} ${hours === 1 ? "hora" : "horas"}`;
  } else {
    const days = Math.floor(abs / MINUTES_IN_DAY);
    amount = `${days} ${days === 1 ? "dia" : "dias"}`;
  }

  return {
    overdue,
    text: overdue ? `Vencido há ${amount}` : `Vence em ${amount}`
  };
};

// Versao compacta para o badge da tabela: "Vencido há 22d" / "Vence hoje" /
// "Vence em 1d". Usa abreviacao (d/h/min) e trata o mesmo dia como "hoje".
export const formatDueBadge = minutes => {
  const safe = Number.isFinite(minutes) ? minutes : 0;
  const overdue = safe < 0;
  const abs = Math.abs(safe);

  const compact =
    abs >= MINUTES_IN_DAY
      ? `${Math.floor(abs / MINUTES_IN_DAY)}d`
      : abs >= MINUTES_IN_HOUR
      ? `${Math.floor(abs / MINUTES_IN_HOUR)}h`
      : `${Math.floor(abs)}min`;

  if (overdue) {
    return { overdue: true, text: `Vencido há ${compact}` };
  }

  if (safe < MINUTES_IN_DAY) {
    return { overdue: false, text: "Vence hoje" };
  }

  return { overdue: false, text: `Vence em ${compact}` };
};
